import { useState } from "react";
import { SelectTypeDTO } from "../../../dtos/SelectTypeDTO";
import { IDisciplineData } from "..";
import { mapDiciplineObject } from "../../../utils/mapDiciplineObject";
import { api } from "../../../service/api";

interface ITimerSeconds {
  diciplineSelected: IDisciplineData[];
  jury: string;
  modality: string;
  year: string;
}

export function useListTimerSeconds() {
  const [loadingTimerSeconds, setLoadingTimerSeconds] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataLisTimerSeconds, setDataLisTimerSeconds] = useState<
    SelectTypeDTO[]
  >([]);

  const fetchData = async ({
    diciplineSelected,
    jury,
    modality,
    year,
  }: ITimerSeconds) => {
    try {
      const filterDicipline = mapDiciplineObject(diciplineSelected);
      setDataLisTimerSeconds([]);
      setLoadingTimerSeconds(true);
      const path = `/simulator/list/filter/timeinseconds?disciplines_subjects=${filterDicipline}&jury=${jury}&modality=${modality}&year=${year}`;
      const response = await api.get(path);

      const data: SelectTypeDTO[] = [];

      response.data.forEach((element: any) => {
        data.push({
          label: element.time_in_seconds,
          value: element.time_in_seconds,
        });
      });

      setDataLisTimerSeconds(data);
    } catch (error) {
      setError(true);
    } finally {
      setLoadingTimerSeconds(false);
    }
  };

  return {
    dataLisTimerSeconds,
    loadingTimerSeconds,
    error,
    refetchTimerSeconds: fetchData,
  };
}
